export { default as common } from "./common";
import rates from "./cardRates";
import cardAdditionalInfo from "./cardAdditionalInfo";

export const card = {
  rates,
  cardAdditionalInfo,
};
